
import { userService } from '@/services/user.service'
import {AuthService} from "@/services/auth";
import router from '../router/'
const state = {
    status: { loggedIn: true },
    token: null,
    loading: false,
    drawer: true,
    user: {
        id: '',
        name: '',
    },
    lastTrxPhoneNumber: ''
};

const actions = {
    login({ dispatch, commit }, { email, password }) {
        //commit('loginRequest', { username });
        commit('setloading', true);
        AuthService.login(email, password)
            .then(
                user => {
                    //commit('setloading', false);
                    commit('loginSuccess', user);
                    dispatch('alert/success', 'Login Successfully', { root: true });
                    router.push('/dashboard');
                },
                error => {
                    commit('loginFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    initStore({commit }) {
        commit('initialiseStore');
    },
    stateDrawer({commit }) {
        commit('getDrawerstatex');
    },
    logout({ commit }) {
        userService.logout();
        //router.push('/login');
        commit('logout');
    },
    gantipass({ dispatch }, { pass }) {
        userService.changepass(pass)
            .then(data => {
                router.push('/login');
                dispatch('alert/success', data.msg, { root: true });
            }, error => {
                console.log('changepass error')
                dispatch('alert/error', error, { root: true });
            })
    },
    resetpass({ dispatch }, { email }) {
        console.log("pass:" + email);
        userService.resetpassword(email)
            .then(data => {
                router.push('/login');
                dispatch('alert/success', data.msg, { root: true });
            }, error => {
                console.log('changepass error')
                dispatch('alert/error', error, { root: true });
            })
    },
    getme({ dispatch, commit }) {
        userService.getme()
            .then(data => {
                commit('getmex', data);
            }, error => {
                console.log('getme error')
                userService.logout();
                commit('loginFailure', error);
                dispatch('alert/error', error, { root: true });
            });
    },

    register({ dispatch, commit }, user) {
        commit('registerRequest', user);

        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    router.push('/login');
                    setTimeout(() => {
                        // display success message after route change completes
                        dispatch('alert/success', 'Registration successful', { root: true });
                    })
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('alert/error', error, { root: true });
                    window.getApp.$emit("APP_ACCESS_DENIED", error);
                }
            );
    }
};

const mutations = {
    setloading(state,status) {
        state.loading = status;
    },
    getDrawerstatex(state) {
        state.drawer = !state.drawer;
    },
    loginSuccess(state, user) {
        state.loading = false;
        state.status = { loggedIn: true };
        state.user = { id: user.id, name: user.name };
        state.token = user.token;
    },
    getmex(state, user) {
        console.log('getMe:' + JSON.stringify(user.data));
        state.user = { id: user.data.id, name: user.data.name };
    },
    loginFailure(state) {
        state.loading = false;
        state.status = {};
        state.user = { id: null, name: null };
        state.token = null;
    },
    logout(state) {
        state.status = {};
        state.user = { id: null, name: null };
        state.token = null;
        state.loading = false;
    },
    registerRequest(state, user) {
        console.log(user);
        state.status = { registering: true };
    },
    registerSuccess(state, user) {
        console.log(user);
        state.status = {};
    },
    registerFailure(state, error) {
        console.log(error);
        state.status = {};
    },
    initialiseStore() {
        console.log("initialiseStore");
        this.token = "";
    }
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations
};
